const CATALOG_URL = '/api/v1/catalog'

function readLocalStorage(key, fallback) {
  try { return JSON.parse(localStorage.getItem(key)) ?? fallback } catch { return fallback }
}

export function premiumSlice(set, get) {
  return {
    hasAHPremium: readLocalStorage('ah-premium', false),
    catalog: null,
    catalogLoading: false,

    toggleAHPremium: () => {
      const next = !get().hasAHPremium
      localStorage.setItem('ah-premium', JSON.stringify(next))
      set({ hasAHPremium: next })
      if (next && !get().catalog) get().fetchCatalog()
    },

    fetchCatalog: async () => {
      set({ catalogLoading: true })
      try {
        const res = await fetch(CATALOG_URL)
        if (res.ok) {
          const data = await res.json()
          set({ catalog: data })
        }
      } catch (err) {
        console.warn('[Catalog]', err.message)
      } finally {
        set({ catalogLoading: false })
      }
    },
  }
}
